import { formatRelativeDateTime } from "./format-relative-date-time";
import { getLanguage } from "./get-language";

export function mergeArrays<T, U>(
  timestamps: T[],
  data: U[],
): { timestamp: T; data: U }[] {
  const lang = getLanguage();

  return timestamps.map((timestamp, index) => ({
    timestamp: formatRelativeDateTime(timestamp as string, lang) as T,
    data: data[index],
  }));
}
